export enum NotificationEventType {
  OfferAccess,
  TicketReply,
  PayoutChanged,
}
